import { combineLatestTyped, useStreamEffect } from 'annotation-tools/utils';
import React, { FC, memo } from 'react';
import { createModelImage } from '../../../../api/fetch-functions/model-image';
import { token$ } from '../../../../global-state/auth-state';
import { fetchModelImageListOf } from '../../../../global-state/database/model-image-list';
import { modelId$ } from '../../../../global-state/router-id';
import { useTusUploaderSingleFile } from '../../../../tus-image-upload/use-tus-uploader-single-file';
import { DndFileUploadAreaView } from '../../../shared/dnd-file-upload-area-view';

export const DndFileUploadArea: FC<{}> = memo(() => {
  const {
    dropzoneRootProps,
    dropzoneInputProps,
    isDragActive,
    autoHideErrorMessage,
    isUploading,
    uploadPercentage,
    cancelOnClick,
    uploadCompletedFileGuid$
  } = useTusUploaderSingleFile(3000);

  /* effect */

  useStreamEffect(
    combineLatestTyped(token$, uploadCompletedFileGuid$, modelId$),
    ([token, fileGuid, modelId]) => {
      if (
        token !== undefined &&
        modelId !== undefined &&
        fileGuid !== undefined
      ) {
        createModelImage(token)(modelId)({ fileGuid }).then(res => {
          if (res.type === 'success') {
            fetchModelImageListOf(modelId);
          }
        });
      }
    }
  );

  return (
    <DndFileUploadAreaView
      dropzoneRootProps={dropzoneRootProps}
      dropzoneInputProps={dropzoneInputProps}
      isDragActive={isDragActive}
      errorMessage={autoHideErrorMessage}
      isUploading={isUploading}
      uploadPercentage={uploadPercentage}
      cancelUploading={cancelOnClick}
    />
  );
});

DndFileUploadArea.displayName = 'DndFileUploadArea';
